export const environment = {
  production: true,
  enableDebug: false,
  env: "NEXT-V3",
  appVersion: "3024394527-3.0.70-20261103-590fd67b",
  apiUrl: "https://api-next.eva-it.ch/api",
  agentUrl: "",
  intercomId: "jdgxwp9j",
  sfLicense: "Ngo9BigBOggjHTQxAR8/V1NCaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXdfdHVVR2FdUkR+V0A=",
  stripePublishableKey:
    "pk_live_51NNbeHKC54OGG3aLbt3kOOPSuZidH8wquslv5YVMoXl4XFQCdSxX5BbLNBrSFAMfT3om5GNWN8kOVrKTLGtruNAl00US7OOw2K",
  googleMapsApiKey: "AIzaSyAqsfn28sKnSiIgB9Tf442WnUgguVbbJok",
};
